<div class="dialog-container">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>Create user</h4>
    <button (click)="dialogRef.close()">
      <fa-icon icon="xmark"></fa-icon>
    </button>
  </div>
</div>
